import { combineReducers } from 'redux'
import { all } from 'redux-saga/effects'
import subscriptionsInfo,{ subscriptionsInfoSaga } from './getSubscriptions'
import subscribersInfo,{ subscribersInfoSaga } from './getSubscribers'
import listsInfo, { listsInfoSaga } from './getLists'
import { subscribersUpdateSaga } from './updateSubscribers'
import archiveValue, { archiveValueSaga } from './archiveValues'
import archiveEmail, { archiveEmailSaga } from './archiveEmails'
import { paidLogsSaga } from './getPaidLogs'
import subscribe, { subscribeListsSaga } from './subscribeList' 
import subscriptionResults, { resultsSaga } from './getResults'

const rootReducer = combineReducers({
  subscriptionsInfo,
  subscribersInfo,
  listsInfo,
  // subscribersUpdate,
  archiveValue,
  archiveEmail,
  subscribe,
  subscriptionResults
})

export function* rootSaga(){
  yield all([
    subscriptionsInfoSaga(),
    subscribersInfoSaga(),
    listsInfoSaga(),
    subscribersUpdateSaga(),
    archiveValueSaga(),
    archiveEmailSaga(),
    paidLogsSaga(),
    subscribeListsSaga(),
    resultsSaga(),
  ])
}

export default rootReducer

export type RootState = ReturnType<typeof rootReducer>

